import React, { useState, useEffect } from 'react'
import Stepflow from './stepflow';

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import { IoReceiptSharp } from "react-icons/io5";
import SearchIcon from '@mui/icons-material/Search';
import PopUpViewFlowstatus from '../viewflowprocess/PopUpViewFlowstatus';
import Badge from '@mui/material/Badge';
import { BsSendCheckFill } from "react-icons/bs";
import { useDemoData } from '@mui/x-data-grid-generator';
import { GridToolbar } from '@mui/x-data-grid';
import AppDataGrid from '../../../../components/datatable/AppDataGrid';
import PageviewIcon from '@mui/icons-material/Pageview';
import Tooltip from '@mui/material/Tooltip';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import FetchApi from '../../../customhooks/Functionapi';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import AppsIcon from '@mui/icons-material/Apps';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { GridActions, ActionButton, ActionPopup, StatusChip } from '../../../../components/datatable/GridActions';

const columns = [
    // { field: 'num', headerName: 'NO', width: 50 },
    {
        field: 'JournalCode',
        headerName: 'Journal code',
        width: 150,
        // editable: true,
    },
    {
        field: 'TransDate',
        headerName: 'TransDate',
        width: 120,
        // editable: true,
    },
    {
        field: 'ItemTypeID',
        headerName: 'ItemTypeID',
        // type: 'number',
        width: 100,
        // editable: true,
    },
    {
        field: 'CustID',
        headerName: 'CustID',
        // type: 'number',
        width: 100,
        // editable: true,
    },
    {
        field: 'ItemID',
        headerName: 'ItemID',
        // type: 'number',
        width: 110,
        // editable: true,
    },
        {
        field: 'ItemName',
        headerName: 'ItemName',
        // type: 'number',
        width: 250,
        // editable: true,
    },
    {
        field: 'statusName',
        headerName: 'status flow',
        // type: 'number',
        width: 150,
          renderCell: (params) => <StatusChip label={params.row.statusName} />
        // editable: true,
    },

    {
        field: 'Processflow',
        headerName: 'Process flow',
        sortable: false,
        width: 200,
        renderCell: (params) => {
            return (
                <div style={{ flexDirection: 'row', alignContent: 'flex-start', display: 'flex' }}>

                    <Stepflow 
                    stateflow={params.row.stateflow}
                        endstateflow={params.row.frstateflow}
                        statusflow={params.row.statusflow}
                        activerecieved={params.row.activerecieved}
                        activeapproved={params.row.activeapproved}
                    />

                </div>
            )
        }

    },
    {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 200,
        minWidth: 200,
        sortable: false,
        cellClassName: 'actions',
        renderCell: (params) => {
            const row = params.row;
            return (
                <GridActions>
                    {row.userFlowStatus == '101' &&
                        <ActionButton to={`/draftAdddocuments/${row.JournalID}`} title="Add slot" tone="add">
                            <NoteAddIcon />
                        </ActionButton>}
                    {row.statusActions == '111' && <>
                        <ActionButton to={`/viewdocument/${row.JournalID}/${row.statusflow}`} title="View" tone="view">
                            <VisibilityIcon />
                        </ActionButton>
                        <ActionPopup tone="flow"><PopUpViewFlowstatus jourId={row.JournalID} /></ActionPopup>
                    </>}
                    {row.statusActions == '101' &&
                        <ActionButton to={`/viewdocument/${row.JournalID}/${row.statusActions}`} title="Approved" tone="send">
                            <BsSendCheckFill />
                        </ActionButton>}
                    {row.statusActions == '112' &&
                        <ActionButton to={`/viewdocument/${row.JournalID}/${row.statusActions}`} title="Receive" tone="revise">
                            <IoReceiptSharp />
                        </ActionButton>}
                    {row.statusActions == '103' &&
                        <ActionButton to={`/viewdocument/${row.JournalID}/${row.statusActions}`} title="Approved" tone="send">
                            <BsSendCheckFill />
                        </ActionButton>}
                    {(row.statusActions == '201' || row.statusActions == '202') &&
                        <ActionButton to={`/editRejectdocument/${row.JournalID}/${row.statusActions}`} title="Edit" tone="edit">
                            <ModeEditIcon />
                        </ActionButton>}
                    {row.statusActions == '104' && <>
                        <ActionButton to={`/viewdocument/${row.JournalID}/${row.statusActions}`} title="View" tone="view">
                            <VisibilityIcon />
                        </ActionButton>
                        <ActionPopup tone="flow"><PopUpViewFlowstatus jourId={row.JournalID} /></ActionPopup>
                    </>}
                </GridActions>
            )
        }
    }
];


const Approvedlist = () => {

    const FetchApis = new FetchApi();
    const userId = sessionStorage.getItem('userId')
    const [journalList, setJournalList] = useState([])
    const [dataAll, setDataAll] = useState([])

    const [countInpreveiw, setCountInpreveiw] = useState(0)
    const [countPading, setCountPading] = useState(0)
    const [countReject, setCountReject] = useState(0)
    const [countRejectEdit, setCountRejectEid] = useState(0)
    const [countapproved, setCountApproved] = useState(0)

    const { data, loading } = useDemoData({
        dataSet: 'Commodity',
        rowLength: 10,
        maxColumns: 6,
    });

    useEffect(() => {

        journalAll()
        getstatusAll()

    }, [])

    function getRowId(row) {
        return row.JournalID;
    }

    const journalAll = () => {

        FetchApis.FethcGet(`/document/DocumentByStateAll/${userId}`).then(res => {

            if (res.status == 200) {
                setJournalList(res.data);
                console.log(res.data);

                setDataAll(res.data);
            }

        })

    }

    const journalInpreview = () => {

        FetchApis.FethcGet(`/document/DocumentInpreview/${userId}`).then(res => {
            if (res.status == 200) {
                setJournalList(res.data);
                console.log(res.data);
            }

        })
    }

    const journalpanding = () => {
        FetchApis.FethcGet(`/document/DocumentPreRecieved/${userId}`).then(res => {
            if (res.status == 200) {
                setJournalList(res.data);
                console.log(res.data);
            }

        })

    }

    // ค้นหาจาก transition table
    const journalApproved = () => {
        FetchApis.FethcGet(`/document/DocumentApprovedlist/${userId}`).then(res => {

            if (res.status == 200) {
                setJournalList(res.data);

            }

        })
    }


    // ค้นหาจาก transition table
    const journalReject = () => {

        FetchApis.FethcGet(`/document/DocumentRejectlist/${userId}`).then(res => {
            if (res.status == 200) {
                setJournalList(res.data);
               

            }

        })

    }

    const journalRejectSuccess = () => {

        FetchApis.FethcGet(`/document/DocumentRejectlistsuccessful/${userId}`).then(res => {
            if (res.status == 200) {
            //    console.log(res.data);
               setJournalList(res.data);
            }
        })
    }

    async function getstatusAll() {
        await FetchApis.FethcGet(`/document/DocumentInpreview/${userId}`).then(res => { // รอ approved
            console.log(res)
            if (res.status == 200) {
                setCountInpreveiw(res.data.length)
            }

        })

        await FetchApis.FethcGet(`/document/DocumentPreRecieved/${userId}`).then(res => { // รอ recieved
            if (res.status == 200) {
                setCountPading(res.data.length)
                console.log(res.data);
            }

        })

        await FetchApis.FethcGet(`/document/DocumentApprovedlist/${userId}`).then(res => { // approved แล้ว
            console.log(res)
            if (res.status == 200) {
                setCountApproved(res.data.length)
            }

        })

        await FetchApis.FethcGet(`/document/DocumentRejectlist/${userId}`).then(res => { // รายการที่ reject กลับมา

            if (res.status == 200) {
                setCountReject(res.data.length)
                console.log(res.data);
            }
        })

        await FetchApis.FethcGet(`/document/DocumentRejectlistsuccessful/${userId}`).then(res => {
            if (res.status == 200) {
                setCountRejectEid(res.data.length);

            }

        })
    }

    const filterBySearch = (event) => {

        const query = event.target.value;
        const filteredData = dataAll.filter(item => {
            return Object.values(item)
                .join('')
                .toLowerCase()
                .includes(query.toLowerCase());
        });

        setJournalList(filteredData);
    };


    return (
        <div>
            <div style={{ width: '100%', marginTop: 50 }}>

                <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', padding: 10 }}>

                    <div style={{ marginLeft: '2%', display: 'flex' }}>
                        <Paper
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                        >
                            <IconButton sx={{ p: '10px' }} aria-label="menu">
                                <MenuIcon />
                            </IconButton>
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Search Journal by Id"
                                inputProps={{ 'aria-label': 'search document' }}
                                onChange={(e) => filterBySearch(e)}

                            />
                            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                <SearchIcon />
                            </IconButton>
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        </Paper>
                    </div>

                    <div style={{ marginRight: '5%', display: 'flex' }}>
                        {[
                            { label: 'ALL', icon: <AppsIcon />, onClick: journalAll, bg: '#272626', color: '#fff' },
                            { label: 'In preview', icon: <VisibilityIcon />, onClick: journalInpreview, bg: '#bfdcf5', color: '#1c24a8', count: countInpreveiw },
                            { label: 'Pending', icon: <HourglassTopIcon />, onClick: journalpanding, bg: '#f5d593', color: '#ef8b1b', count: countPading },
                            { label: 'Approved', icon: <CheckCircleIcon />, onClick: journalApproved, bg: '#abecdc', color: '#398d27', count: countapproved, badgeColor: 'primary' },
                            { label: 'Reject', icon: <HighlightOffIcon />, onClick: journalReject, bg: '#f7a893', color: '#f14c1f', count: countReject },
                            { label: 'Reject Successful', icon: <TaskAltIcon />, onClick: journalRejectSuccess, bg: '#f7a893', color: '#f14c1f', count: countRejectEdit },
                        ].map((btn) => (
                            <div key={btn.label} style={{ marginRight: 5, padding: 5 }}>
                                <Badge color={btn.badgeColor || 'error'} badgeContent={btn.count} max={99}>
                                    <Button
                                        onClick={() => btn.onClick()}
                                        startIcon={btn.icon}
                                        sx={{
                                            backgroundColor: btn.bg,
                                            color: btn.color,
                                            borderRadius: '10px',
                                            px: 1.75,
                                            py: 0.75,
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                                            transition: 'transform .15s, box-shadow .15s, filter .15s',
                                            '&:hover': {
                                                backgroundColor: btn.bg,
                                                filter: 'brightness(0.95)',
                                                transform: 'translateY(-1px)',
                                                boxShadow: '0 4px 10px rgba(0,0,0,0.16)',
                                            },
                                        }}
                                    >
                                        {btn.label}
                                    </Button>
                                </Badge>
                            </div>
                        ))}
                    </div>

                </div>
                <div>
                    <label style={{ fontSize: 18, color: '#807c7c' }}>Total list  ( {journalList.length} ) </label>
                </div>

                <div style={{ height: 'auto', width: '100%' }}>

                    <AppDataGrid
                        rows={journalList}
                        getRowId={getRowId}
                        columns={columns}
                        loading={loading}
                        slots={{ toolbar: GridToolbar }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                },
                            },
                        }}
                        pageSizeOptions={[10, 25, 50, 100]}
                    />

                </div>
            </div>
        </div>
    )
}

export default Approvedlist